/**
 * @file prepareDiseases.js
 * @description marks biocurated diseases as approved
 *              based on provided geneModelDiseases
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since May 23, 2022 14:52
 */
import lodash from 'lodash';

import { assertParam } from 'src/@common/asserts';
import { arrayExists } from 'src/@common/utilities';

function prepareDiseases(
    biocuratedDiseases,
    geneModelDiseases) {

    assertParam('biocuratedDiseases', biocuratedDiseases);
    assertParam('geneModelDiseases', geneModelDiseases);

    const state = {
        diseases: [],
        message: '',
    };

    if (arrayExists(biocuratedDiseases)) {
        biocuratedDiseases.forEach((disease) => {
            state.diseases.push({
                name: disease.name,
                id: disease.id,
                approved: false,
                source: disease.source,
            });
        });
    }

    if (arrayExists(geneModelDiseases)) {

        if (arrayExists(biocuratedDiseases)) {

            geneModelDiseases.forEach((gmDisease) => {

                const foundIndex = state.diseases.findIndex((disease) => {
                    return gmDisease.id === disease.id;
                });

                if (foundIndex !== -1) {
                    // update the existing biocuratedDisease
                    state.diseases[foundIndex].approved = true;

                } else {
                    // geneModel.disease doesn't exist in the biocurated disease. add it.
                    state.diseases.push({
                        name: gmDisease.name,
                        id: gmDisease.id,
                        approved: true,
                        source: gmDisease.source,
                    });
                }

            });

        } else {
            // biocurated diseases don't exist.
            // add the geneModel diseases anyway
            geneModelDiseases.forEach((gmDisease) => {
                state.diseases.push({
                    name: gmDisease.name,
                    id: gmDisease.id,
                    approved: true,
                    source: gmDisease.source,
                });

            });
        }
    }

    state.diseases =
        lodash.orderBy(state.diseases, ['approved', 'name'], ['desc', 'asc']);

    return state.diseases;
}

export default prepareDiseases;